import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58c1ad3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inner" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_3 = { class: "text" }

import {computed, withDefaults} from 'vue'

  import SpriteIcon from '@/components/SpriteIcon'
  import ButtonInput from './ButtonInput'

  enum ButtonPriority {
    primary = 'primary',
    secondary = 'secondary',
    low = 'low'
  }

  export interface Props {
    active?: boolean
    priority?: ButtonPriority
    name: string
    value?: any
    modelValue?: any
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'IconButton',
  props: {
    active: { type: Boolean, default: true },
    priority: { default: 'primary' },
    name: null,
    value: { default: 1 },
    modelValue: null
  },
  emits: {
    'update:modelValue': (value) => {
      return !!value
    },

    click: () => {
      return true
    }
  },
  setup(__props: any, { emit }) {

const props = __props as { active: boolean, priority: ButtonPriority, name: string, value: any, modelValue?: any };

  

  

  const isRTLAndSubmit = computed(
    () => document.body.classList.contains('rtl') && props.name === 'submit'
  )

  const needMargin = computed(() => {
    return (
      document.body.classList.contains('rtl') &&
      (props.name === 'share' || props.name === 'replay')
    )
  })

  const resource = computed({
    get() {
      return props.modelValue || {}
    },

    set() {
      emit('update:modelValue', props.value || 1)
    }
  })

  const onClick = () => {
    if (props.value) {
      resource.value = props.value
    }

    emit('click')
  }

  console.log(props.name)

  const classList = computed(() => {
    return {
      [`is-${props.name}-icon`]: true
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ButtonInput), {
    modelValue: _unref(resource),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(resource) ? (resource).value = $event : null)),
    value: props.value,
    class: _normalizeClass(["icon-button", _unref(classList)]),
    active: props.active,
    priority: props.priority,
    onClick: onClick
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        (props.name)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass({'icon-spacer': true, rotated: _unref(isRTLAndSubmit), marged: _unref(needMargin)})
            }, [
              _createVNode(_unref(SpriteIcon), {
                name: props.name,
                class: "icon"
              }, null, 8, ["name"])
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 8, ["modelValue", "value", "class", "active", "priority"]))
}
}

})